import {useMemo} from 'react';
import {allSavedCarts} from '@netx/core-cart/singletons/savedCarts';
import useBackboneCollection from '@netx/core-components/hooks/useBackboneCollection';
import {useConstCallback} from '@netx/core-components/hooks/useConstCallback';
import {
	useFilterItems,
	UseFilterItemsParams,
} from '@netx/core-components/hooks/useFilterItems';
import {SharedResourceMode} from '@netx/core-share/constants';
import type {SharedResource} from '@netx/core-share/types';
import {filterSharedResourcesByMode} from '@netx/core-share/utils';

export type UseSavedCartsParams = {
	filterMode?: SharedResourceMode;
};

export const useSavedCarts = ({filterMode}: UseSavedCartsParams = {}) => {
	const savedCarts = useBackboneCollection(allSavedCarts, false);

	const {filteredItems, ...filterRest} = useFilterItems({
		filterFn: useConstCallback<
			UseFilterItemsParams<SharedResource>['filterFn']
		>((filter, items) =>
			items.filter((item) => item.title.toLowerCase().includes(filter)),
		),
		items: useMemo(
			() => filterSharedResourcesByMode(savedCarts, filterMode),
			[savedCarts, filterMode],
		),
	});

	return {
		...filterRest,
		savedCarts: filteredItems,
	};
};

export default useSavedCarts;
